/**
 * Error code definitions
 *
 * Defines standardized error codes used throughout the SDK for consistent error handling.
 */

/**
 * Enumeration of all possible error codes that can be returned by the SDK
 */
export enum ErrorCodes {
  // Authentication & Authorization
  /** User is not authenticated */
  UNAUTHORIZED = "UNAUTHORIZED",
  /** User lacks permission for the requested operation */
  FORBIDDEN = "FORBIDDEN",

  // Validation
  /** Request data failed validation */
  VALIDATION_ERROR = "VALIDATION_ERROR",

  // HTTP Status Codes
  /** Requested resource was not found */
  RESOURCE_NOT_FOUND = "RESOURCE_NOT_FOUND",
  /** Idempotent operation was already processed (409); safe to treat as done */
  DUPLICATE_ATTEMPT = "DUPLICATE_ATTEMPT",
  /** Request timed out */
  TIMEOUT_ERROR = "TIMEOUT_ERROR",
  /** Rate limit has been exceeded */
  RATE_LIMIT_EXCEEDED = "RATE_LIMIT_EXCEEDED",
  /** Internal server error occurred */
  INTERNAL_SERVER_ERROR = "INTERNAL_SERVER_ERROR",
  /** Service is temporarily unavailable */
  SERVICE_UNAVAILABLE = "SERVICE_UNAVAILABLE",

  // SDK Specific
  /** Network connectivity error */
  NETWORK_ERROR = "NETWORK_ERROR",
  /** External API call failed */
  EXTERNAL_API_ERROR = "EXTERNAL_API_ERROR",
}
